define([
    "underscore",
    "backbone"
], function(_, Backbone) {
    return Backbone.Model.extend({
        idAttribute: 'callback_request_cd',
        url: "/rest_callback_request/",

        validation: {
            full_name: {
                required: true
            },
            phone_country: {
                required: true
            },
            email: {
                required: true,
                pattern: 'email'
            },
            phone_area:{
                required: true
            },
            phone_rest: {
                required: true
            },
            comment: {
                required: true
            },
            preferred_time: {
                required: true
            }
        }
    });
});



//////////////////
// WEBPACK FOOTER
// ./assets/common/main/js/models/callback_request_model.js
// module id = 16
// module chunks = 0